import { styled } from '@clickcease/cc-client-components-lib'

export const DomainManagementStyled = styled('div', {
  background: '$white',
  boxShadow: '0px 4px 20px rgba(102, 102, 102, 0.08)',
  width: 'calc(100% - 40px)',
  minHeight: 'calc(100vh - 148px)',
  borderRadius: '$medium',
  display: 'flex',
  flexDirection: 'column',
  padding: '$10',

  variants: {
    isTopBannerVisible: {
      true: {
        minHeight: 'calc(100vh - 198px)',
      },
    },
  },
})

export const DomainManagementTop = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  marginBottom: '$6',
})

export const DomainManagementSearch = styled('div', {
  width: '260px',
})

export const TopLeft = styled('div', {
  display: 'flex',
  justifyContent: 'left',
  width: '45%',
  gap: '$10',
})

export const TopRight = styled('div', {
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: '$2',
  ['> button > button']: {
    height: '18px',
  },

  ['button:last-of-type']: {
    marginLeft: '$4',
  },
})

export const TableHeaderTitle = styled('div', {
  fontWeight: '$sb',
})
